<script>
    import { apiUrl } from "@/utils";
    import TheSvgIcon from "@main/packages/TheSvgIcon";

    export default {
        name: "RecipeCard",
        components: {
            TheSvgIcon,
        },
        props: {
            recipe: Object,
        },
        methods: {
            apiUrl,
        },
    };
</script>

<template>
    <div class="recipe-card">
        <router-link
            :to="{ name: 'RecipeDetail', params: { slug: recipe.slug } }"
            class="recipe-card__link"
        >
            <div class="recipe-card__image">
                <img class="" :src="apiUrl(recipe.previewPicture)" alt="" />
            </div>
            <div class="recipe-card__text">
                <div class="recipe-card__title">{{ recipe.name }}</div>
                <div class="recipe-card__specs">
                    <div v-if="recipe.preparingTime" class="recipe-card__spec">
                        <the-svg-icon name="time"></the-svg-icon>
                        {{ recipe.preparingTime }}
                    </div>
                    <div v-if="recipe.power" class="recipe-card__spec">
                        <the-svg-icon name="power"></the-svg-icon>
                        {{ recipe.power }}
                    </div>
                </div>
            </div>
        </router-link>
    </div>
</template>

<style lang="scss">
    .recipe-card {
        height: 100%;
        padding: 6px 4px 4px;
        border-radius: 12px;
        box-shadow: 0 0 10px #f2f2f5;
        transition: box-shadow 0.2s ease-in;
        &:hover {
            box-shadow: 0 0 0 2px #e0e6e9;
            .recipe-card__image img {
                transform: scale(1.02);
            }
        }
        &.swiper-slide {
            height: auto;
        }
        @include bp($bp-desktop-sm) {
            padding: 8px 8px 16px;
            border-radius: 20px;
            box-shadow: 0 0 25px #f2f2f5;
        }
    }

    .recipe-card__link {
        display: flex;
        flex-direction: column;
        @include bp($bp-desktop-sm) {
            height: 100%;
        }
    }

    .recipe-card__image {
        position: relative;
        padding-bottom: 100%;
        border-radius: 8px;
        overflow: hidden;
        transform: translateZ(0);
        img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border-radius: 8px;
            object-fit: cover;
            transition: transform 0.2s ease-in;
        }
        @include bp($bp-desktop-sm) {
            border-radius: 16px;
            img {
                border-radius: 16px;
            }
        }
    }

    .recipe-card__text {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        padding: 8px 4px 6px;
        @include bp($bp-desktop-sm) {
            padding: 16px 8px 0;
        }
    }

    .recipe-card__title {
        flex-grow: 1;
        margin-bottom: 20px;
        color: var(--primary-text);
        font-size: 12px;
        font-weight: 700;
        line-height: 14px;
        letter-spacing: -0.02em;
        @include bp($bp-desktop-sm) {
            margin-bottom: 16px;
            font-size: 16px;
            line-height: 20px;
            letter-spacing: 0;
        }
    }

    .recipe-card__specs {
        @include bp($bp-desktop-sm) {
            display: flex;
            align-items: center;
        }
    }

    .recipe-card__spec {
        display: flex;
        align-items: center;
        color: var(--secondary-text);
        font-size: 12px;
        line-height: 20px;
        white-space: nowrap;
        svg {
            @include box(16px);
            margin-right: 10px;
        }
        @include bp($bp-desktop-sm) {
            margin-right: 24px;
            font-size: 14px;
            svg {
                @include box(24px);
                margin-right: 6px;
            }
        }
    }
</style>
